/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-09-06 13:53:28
 * @LastEditors: linxi
 * @LastEditTime: 2025-11-19 11:04:51
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Form,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  DatePicker,
  Checkbox,
  Col,
  Popover,
  Input,
} from 'antd'
import { unwatchFile } from 'fs'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { DateTimeFormatSimple } from '../../models/datetime'
import { QuestionCircleTwoTone } from '@ant-design/icons'

export const Query = (props: {
  onValueChange: (params: any) => void
  Configuration?: () => void
}): ReactElement => {
  const [form] = Form.useForm()

  const { Option } = Select

  const { RangePicker } = DatePicker

  const dispatch = useDispatch<RootDispatch>()

  const [timeList, setTimeList] = useState<any>()

  useEffect(() => {
    setTimeList([moment().startOf('day'), moment().endOf('day')])
    form.setFieldsValue({
      time: [moment().startOf('day'), moment().endOf('day')],
    })
    form.submit()
  }, [])

  return (
    <Form
      form={form}
      initialValues={{
        searchWay: true, // 默认勾选排除离休
        yidibz: 0, // 默认勾选本地
      }}
      onFinish={(values) => {
        const startTime = moment(values?.time?.[0])
          ?.startOf('day')
          ?.format(DateTimeFormatSimple)
        const endTime = moment(values?.time?.[1])
          ?.endOf('day')
          ?.format(DateTimeFormatSimple)
        props.onValueChange({
          ...values,
          startTime: startTime,
          endTime: endTime,
          time: undefined,
        })
      }}
    >
      <Row style={{ marginLeft: 4, marginBottom: 10 }} justify='space-between'>
        <Space>
          <Form.Item name='time' noStyle>
            <RangePicker
              // format={DateTimeFormatSimple}
              style={{ width: '16em' }}
              onChange={(v: any) => {
                setTimeList(v)
                form.submit()
              }}
            />
          </Form.Item>
          <Form.Item name='tenantName' noStyle>
            <Input
              allowClear={true}
              placeholder='机构名称'
              style={{ width: '10em' }}
              onChange={(v: any) => {
                form.submit()
              }}
            />
          </Form.Item>
          <Form.Item name='businessType' noStyle>
            <Select
              placeholder='业务类型'
              allowClear
              style={{ width: '10em' }}
              onChange={(v: any) => {
                form.submit()
              }}
            >
              <Option value={10}>西医病历</Option>
              <Option value={11}>中医病历</Option>
              <Option value={12}>口腔</Option>
              <Option value={20}>审方</Option>
              <Option value={30}>辅诊</Option>
            </Select>
          </Form.Item>
          <Button
            type='primary'
            onClick={() => {
              form.submit()
            }}
          >
            查询
          </Button>
        </Space>
        <Space>
          <Button
            type='primary'
            ghost
            onClick={() => {
              props?.Configuration && props?.Configuration()
            }}
          >
            模型配置
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
